import {Controller} from "@hotwired/stimulus"
import Sortable from "sortablejs"
import {patch} from "@rails/request.js"

export default class StimulusSortable extends Controller {
    static values = {
        resourceName: String,
        paramName: {
            type: String,
            default: "position"
        },
        responseKind: {
            type: String,
            default: "html"
        },
        animation: Number,
        handle: String,
        css: String,
        parentName: String,
        group: String,
        shared: String
    }

    initialize() {
        this.onUpdate = this.onUpdate.bind(this)
    }

    connect() {
        if (Sortable.active) {
            this.sortable = Sortable.get(this.element)
        } else {
            this.sortable = new Sortable(this.element, {
                ...this.defaultOptions,
                ...this.options
            })
        }
    }

    disconnect() {
        if (!Sortable.active) {
            this.sortable.destroy()
        }
        this.sortable = undefined
    }

    async onUpdate(event) {
        this.dispatch("update", { detail: { item: event.item, newIndex: event.newIndex } })

        const { item, newIndex } = event
        if (!item.dataset.sortableUpdateUrl) return

        const param = this.resourceNameValue
            ? `${this.resourceNameValue}[${this.paramNameValue}]`
            : this.paramNameValue

        const data = new FormData()
        data.append(param, newIndex + 1)

        return await patch(item.dataset.sortableUpdateUrl, {
            body: data,
            responseKind: this.responseKindValue
        })
    }

    get options() {
        let group
        let sort
        let onAdd
        if (this.parentNameValue) {
            group = {name: this.parentNameValue, pull: "clone", put: false};
            sort = false
            onAdd = (event) => this.onAdd(event)
        } else if (this.groupValue) {
            group = {name: "shared", pull: false};
            sort = true
            onAdd = (event) => this.onAdd(event)
        } else if (this.sharedValue) {
            group = this.sharedValue;
            sort = true
            onAdd = (event) => this.changeCss(event)

        } else {
            group = undefined;
            sort = true
        }
        return {
            animation: this.animationValue || this.defaultOptions.animation || 150,
            handle: this.handleValue || this.defaultOptions.handle || undefined,
            filter: ".add-button",
            group: group,
            sort: sort,
            onAdd: onAdd,
            onUpdate: this.onUpdate,
            onMove: (evt) => {
                return !evt.related.classList.contains('add-button');
            }
        }
    }

    get defaultOptions() {
        return {
            animation: 500,
            ghostClass: this.cssValue || "bg-sky-200"
        }
    }

    onAdd(event) {
        const item = event.item
        const to = event.to
        let url = to.dataset.url
        let token = document.querySelector('meta[name="csrf-token"]').content
        let position = event.newIndex
        let scope = to.dataset.paramScope
        fetch(url, {

            method: "PATCH",
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json",
                "Accept": "text/vnd.turbo-stream.html"
            },
            body: JSON.stringify({
                [scope]: {
                    label: item.textContent.trim(),
                    field: item.dataset.field,
                    function: item.dataset.function,
                    include_in_group_by: item.dataset.includeGroup,
                },
                position: position,
                source: item.dataset.source,
                argument: item.dataset.argument,
                currency: item.dataset.currency,
                uniq_id: item.dataset.id
            }),
        })
            .then((response) => response.text())
            .then((html) => {
                Turbo.renderStreamMessage(html)
            })

    }

    changeCss(event) {
        const item = event.item;
        const to = event.to;
        const from = event.from;
        let url = item.dataset.url
        let token = document.querySelector('meta[name="csrf-token"]').content
        let position = event.newIndex
        fetch(url, {
            method: "PATCH",
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json",
                "Accept": "text/vnd.turbo-stream.html"
            },
            body: JSON.stringify({
                page_block_id: to.dataset.parentId,
                position: position,
                block_ids: [to.dataset.parentId,from.dataset.parentId]
            }),
        })
            .then((response) => response.text())
            .then((html) => {
                Turbo.renderStreamMessage(html)
            })
    }


    handleNewDetailsStructure(parentElement) {
        const newDetails = this.createDetailsElement();
        const newSummary = this.createSummaryElement(parentElement);
        parentElement.classList.remove('pt-[3px]');

        const parentText = parentElement.childNodes[0];
        const parentEdit = parentElement.querySelector('a');

        if (parentText) parentElement.removeChild(parentText);
        this.moveNonULChildren(parentElement, newDetails);
        newDetails.insertBefore(newSummary, newDetails.firstChild);
        parentElement.insertBefore(newDetails, parentElement.firstChild);
        newDetails.appendChild(parentElement.lastChild);
    }

    createDetailsElement() {
        const newDetails = document.createElement('details');
        newDetails.open = true;
        return newDetails;
    }

    createSummaryElement(parentElement) {
        const newSummary = document.createElement('summary');
        let liText = parentElement.childNodes[0]?.nodeValue?.trim() || '';
        newSummary.innerHTML = `&nbsp;${liText} `;

        const editLink = parentElement.querySelector('a');
        if (editLink) {
            newSummary.appendChild(editLink);
        }

        return newSummary;
    }

    moveNonULChildren(parentElement, newDetails) {
        const children = Array.from(parentElement.childNodes);
        children.forEach(child => {
            if (child.tagName !== 'UL') {
                newDetails.appendChild(child);
            }
        });
    }


}


